<div class="custom-column-filter">
    <div [ngSwitch]="filter.type">
        <div *ngSwitchCase="IColumnFilterType.BOOLEAN_LIST">
            <mat-slide-toggle *ngFor="let option of filter.options"
              class="example-margin"
              [(ngModel)]="option.checked"
              (change)="updateFilter()"
             data-ui-name="Option checked mat slide toggle" data-ui-component="custom-column-filter" data-testid="custom-column-filter-option-checked-mat-slide-toggle">
                {{option.label}}
            </mat-slide-toggle>
        </div>
    </div>
</div>
